
export default function NiSun() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="12"
                cy="12"
                r="8"
                stroke="currentColor"
                stroke-width="1.5"
            ></circle>
            <path
                opacity="0.6"
                d="M2 12L1.5 12"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
            ></path>
            <path
                opacity="0.6"
                d="M22.5 12L22 12"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
            ></path>
            <path
                opacity="0.6"
                d="M12 2L12 1.5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
            ></path>
            <path
                opacity="0.6"
                d="M12 22.5L12 22"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
            ></path>
            <path
                opacity="0.6"
                d="M4.92871 19.071L4.57516 19.4246"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
            ></path>
            <path
                opacity="0.6"
                d="M19.4248 4.57544L19.0713 4.92899"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
            ></path>
            <path
                opacity="0.6"
                d="M4.92871 4.92895L4.57516 4.5754"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
            ></path>
            <path
                opacity="0.6"
                d="M19.4248 19.4246L19.0713 19.071"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
            ></path>
        </svg>
    )
}
